import Navbar from "../component/common/Navbar";
import Footer from "../component/common/Footer";
import PageHero from "../component/common/PageHero";
import ContactForm from "../component/contact/ContactForm";
import styles from "./ContactUs.module.css";

const ContactUs = () => {
  return (
    <div>
      <Navbar />
      <PageHero title="Contact us" />
      <div className={styles.contactContainer}>
        <div className={styles.contactHeader}></div>
        <div className="section">
          <div className={styles.contactSection}>
            <p>
              Get in <span>touch</span>
            </p>
            <ContactForm />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default ContactUs;
